const StatsSection = () => {
  return (
    <section className="bg-[#0f0f0f] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-3 divide-x divide-white/10">
          {[
            { val: '500+', label: 'Successful Closings' },
            { val: '4 Counties', label: 'Service Area' },
            { val: '15+ Years', label: 'Local Experience' },
          ].map((s) => (
            <div key={s.label} className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 px-3 sm:px-8 py-6 text-center sm:text-left">
              <p
                className="text-[#c9a84c] text-2xl sm:text-3xl font-black leading-none shrink-0"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {s.val}
              </p>
              <div className="hidden sm:block w-px h-8 bg-white/10 shrink-0"></div>
              <p className="text-white/60 text-xs font-bold uppercase tracking-widest leading-tight">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
